import React, { useEffect } from 'react';
import { useRegister } from '../../hooks/register';
import { StepsData } from '../../interfaces/StepsData';
import Layout from '../../components/Layout';
import { RegisterForm } from '../../components/registerSteps/Form';
import RegisterSuccess from '../../components/registerSteps/Success';
import RegisterError from '../../components/registerSteps/Error';
import AlreadyRegistered from '../../components/registerSteps/AlreadyRegistered';
import { useModal } from '../../hooks/modal';

export const steps: StepsData = {
  registerForm: <RegisterForm />,
  registerSuccess: <RegisterSuccess />,
  registerError: <RegisterError />,
  alreadyRegistered: <AlreadyRegistered />,
};

export const stepsKeys = Object.keys(steps);

const RegisterPage: React.FC = () => {
  const { step, handleStep, clearData } = useRegister();
  const { handleModal } = useModal();

  useEffect(() => {
    handleModal({ isOpen: false, action: '' });

    if (!stepsKeys.includes(step)) {
      clearData();
      handleStep(stepsKeys[0]);
    }
  }, []);

  return (
    <Layout navbarOff={true} footerOff={true}>
      {steps[step]}
    </Layout>
  );
};

export default RegisterPage;
